import { injectable } from 'inversify';

import { Authority, User } from '@project44/ui-utils';

import { UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase } from '../../domain/abstract';

@injectable()
export class UserTenantSpecificTenantAdminPolicyUpdateCommand extends UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase {
  public readonly execute: UserTenantSpecificTenantAdminPolicyUpdateCommandUseCase['execute'] =
    async (userPrincipal, payload) => {
      this.validateUserPrincipal(userPrincipal);

      const {
        featureFlags,
        userTenantSpecificRolesHandler,
        tenantSpecificTenantAdminPolicy,
      } = payload;

      const {
        composeUserTenantSpecificTenantAdminRoles,
        toUnifiedRoleCollectionDto,
      } = await userTenantSpecificRolesHandler.getUserTenantSpecificRoles();

      const updatedTenantSpecificUserRoles =
        composeUserTenantSpecificTenantAdminRoles(
          tenantSpecificTenantAdminPolicy,
          { featureFlags },
        );

      await userTenantSpecificRolesHandler.updateUserTenantSpecificRoles(
        toUnifiedRoleCollectionDto(updatedTenantSpecificUserRoles),
      );
    };

  public validateUserPrincipal = (userPrincipal: User) => {
    if (
      userPrincipal.hasAnyOfPermissions([
        'SAVE_USER_ROLES' as unknown as Authority,
      ])
    ) {
      return;
    }
    return this.validateUseCase(userPrincipal);
  };
}
